export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
  { id: 2, key: 'COMPANY' },
  { id: 3, key: 'DEAL' },
  { id: 4, key: 'PRODUCT' },
];

// Shown in the "Type" selector when creating a new custom field.
// Checkbox and Percent were removed here (spec 125) - unused in
// production and redundant with List/Multiple Choice - but their
// enum values are kept in ALL_ATTRIBUTE_TYPES so existing fields of
// those types can still be edited without breaking.
export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 2, key: 'CURRENCY' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 8, key: 'MULTIPLE_CHOICE' },
];

// Full list, including types no longer offered on creation. Used to
// resolve/display the type of an already-existing custom field.
export const ALL_ATTRIBUTE_TYPES = [
  ...ATTRIBUTE_TYPES,
  { id: 3, key: 'PERCENT' },
  { id: 7, key: 'CHECKBOX' },
];
